<script setup lang="ts">
useValidatable();
interface Props {
    modelValue?: boolean;
    require?: boolean
}
interface Emits {
    (e: "update:modelValue", value: boolean): void;
}
const props = withDefaults(defineProps<Props>(), {
    modelValue: false,
    require: false
});
const emit = defineEmits<Emits>();
const isError = ref<boolean>(false);

function validate() {
    if (props.modelValue) {
        isError.value = false
        return true
    }
    isError.value = true
    return false
}

function handleInput(event: Event) {
    const target = event.target as HTMLInputElement
    emit('update:modelValue', target.checked);
}


watch(
    () => props.modelValue,
    () => {
        validate();
    },
)

defineExpose({ validate })
</script>

<template>
    <div ref="el" class="agreement my-8">
        <slot></slot>
        <label>
            <input type="checkbox" :checked="modelValue" @change="handleInput" autocomplete="off"/>
            同意する
        </label>
        <FormAlert type="error" class="absolute bottom-0" v-if="isError">同意してお申し込みください</FormAlert>
    </div>

</template>

<style scoped>
.agreement {
    @apply flex flex-col items-center justify-center relative py-4
}
</style>